export const type = 'form.dateTimePicker';
